import React from "react";
import "./BikeShowcase.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation } from "swiper/modules";
import RightSliderArrow from "../../images/right-slider-arrow.svg"
import LeftSliderArrow from "../../images/left-slider-arrow.svg"
import useCityContent from "../../hooks/useCityContent";
import TrinTrinIcon from "../../images/trin-trin-mybyk.svg"
const BikeShowcase = () => {
  const { cityData } = useCityContent();
  return (
    <section className="bike-show bike-features section-padding-sm" >
      <div className="container">
        <div className="bike-show__header">
          <h2 className={cityData.city_name === "mysuru" ? "heading-trin" : ""}>
            {cityData.city_name === "mysuru" ? (
              <>
                Meet <span><img src={TrinTrinIcon} alt="" /></span>
              </>
            ) : cityData.city_name === "jhansi" ? (
              "Meet MYBYK E1"
            ) : (
              "Meet MYBYK PEDAL"
            )}
          </h2>

        </div>
        <div className="bike-show__slider">

          <div className="bike-features__wrap">
            <div className="bike-features__content">
              <div className="custom-swiper-nav sm-none">
                <button className="custom-prev">
                  <img src={LeftSliderArrow} alt="slider-arrow" />
                </button>
                <button className="custom-next">
                  <img src={RightSliderArrow} alt="slider-arrow" />
                </button>
              </div>
              <Swiper
                modules={[Navigation]}
                slidesPerView={3}
                slidesPerGroup={3}
                spaceBetween={40}
                navigation={{
                  nextEl: '.custom-next',
                  prevEl: '.custom-prev',
                }}
                className="bike-features__grid"
                speed={1000}
                breakpoints={{
                  0: {
                    slidesPerView: 1.1,
                    slidesPerGroup: 1
                  },
                  320: {
                    slidesPerView: 1.2,
                    slidesPerGroup: 1,
                    spaceBetween: 18
                  },
                  576: {
                    slidesPerView: 1.5,
                    slidesPerGroup: 1,
                    spaceBetween: 18
                  },
                  767: {
                    slidesPerView: 2.5,
                    slidesPerGroup: 1,
                    spaceBetween: 18
                  },
                  991: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                  }
                }}
              >
                {cityData.bike_showcase.map((details, index) => (
                  <SwiperSlide key={index}>
                    <div className="bike-features__item">
                      <div className="bike-features__item-image">
                        <img src={details.image} alt="details mybyk" loading="lazy" />
                      </div>
                      <div className="bike-features__item-text">
                        <p>{details.title}</p>
                        <span>{details.description}</span>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BikeShowcase;
